import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/DocumentsPage.css";

export default function DocumentSigningComplete() {
  const navigate = useNavigate();

  return (
    <div className="p-6 mt-5" style={{ maxWidth: 560, marginLeft: "auto", marginRight: "auto" }}>
      <div
        style={{
          textAlign: "center",
          padding: "2rem",
          border: "1px solid #e0e0e0",
          borderRadius: 8,
          background: "#fafafa"
        }}
      >
        <h2 style={{ marginBottom: "0.5rem", color: "#2c3e50" }}>Signing complete</h2>
        <p style={{ color: "#666", marginBottom: "1.5rem" }}>
          Your document has been signed successfully. You can view or download it from your documents.
        </p>
        <button
          type="button"
          onClick={() => navigate("/user/esign-documents")}
          style={{
            padding: "10px 24px",
            background: "#D9A128",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontWeight: 600,
            cursor: "pointer"
          }}
        >
          Back to my documents
        </button>
      </div>
    </div>
  );
}
